export default "__VITE_ASSET__DL0jVaV$__"